export default {};

export const defaultFilters = {
  active: [1],
  contractExpiration: ['valid', 'soon', 'expired'],
  projectTypeId: [],
};

export const NONE_PROJECT_TYPE = -1;

const arraysEqual = (a, b) => {
  if (a?.length !== b?.length) return false;
  const setA = new Set(a);
  return b.every((item) => setA.has(item));
};

export const isFilterActive = (filters) => {
  if (!filters) return false;

  const {
    active = defaultFilters.active,
    projectTypeId = [],
    labels: filterLabels = [],
    contractExpiration = defaultFilters.contractExpiration,
    ...customFields
  } = filters;

  // Check standard filters
  const activeChanged = !arraysEqual(active, defaultFilters.active);
  const projectTypeChanged = projectTypeId?.length > 0;
  const labelsChanged = filterLabels?.length > 0;
  const contractChanged = !arraysEqual(contractExpiration, defaultFilters.contractExpiration);

  // Check custom field filters (exclude metadata fields)
  const metadataFields = new Set([
    'filterView', 'filterViewName', 'isFavourite', 'typeId',
  ]);
  const hasCustomFieldFilters = Object.entries(customFields).some(
    ([key, value]) => !metadataFields.has(key) && Array.isArray(value) && value.length > 0,
  );

  return (
    activeChanged
    || projectTypeChanged
    || labelsChanged
    || contractChanged
    || hasCustomFieldFilters
  );
};

export const getFilterData = ({
  projectTypes = [],
  showProjectTypeFilter = true,
  t,
  labels = [],
}) => {
  const additionalFilters = [[
    {
      title: 'Contract',
      key: 'contractExpiration',
      children: [
        {
          title: 'Valid Contract',
          key: 'valid',
        },
        {
          title: 'Expiring Soon',
          key: 'soon',
        },
        {
          title: 'Expired',
          key: 'expired',
        },
      ],
    },
  ]];

  if (showProjectTypeFilter) {
    additionalFilters.push([
      {
        title: `${t('Project')} Type`,
        key: 'projectTypeId',
        children: projectTypes.map((projectType) => ({
          title: projectType.name,
          key: projectType.id,
        })),
      },
    ]);
  }

  const primaryRow = [
    [
      {
        title: 'Archive',
        key: 'active',
        children: [
          {
            title: 'Active',
            key: 1,
          },
          {
            title: 'Archived',
            key: 0,
          },
        ],
      },
    ],
  ];

  if (labels.length > 0) {
    primaryRow.push([
      {
        title: 'Labels',
        key: 'labels',
        children: labels.map(({ title, id }) => ({
          title,
          key: id,
        })),
      },
    ]);
  }


  return [
    primaryRow,
    additionalFilters,
  ];
};
